<template>
  <div>
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="1" ref="qsSearchRef">
        <el-form-item prop="carId" label="车牌号">
          <el-select
            v-model="searchData.carId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="
              (query) => {
                gerCarNoList(query)
              }
            "
            :loading="oLoading.carFuzzySearch"
            @change="carIdChange($event, 'carId', carList, 'id', 'plateNo')"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.plateNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="customerId" label="付款方">
          <el-select
            v-model="searchData.customerId"
            filterable
            :remote="searchData.customerType === 2"
            :remote-method="getPayCustomerList"
            :placeholder="
              (isCustomer && '请先选择付款方类型') || '请输入关键词'
            "
            clearable
            reserve-keyword
            :loading="oLoading.customerFuzzySearch"
            :disabled="isCustomer"
            @change="
              (val) =>
                customerIdChange(val, 'customerId', customerList, 'id', 'customerName')
            "
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="driverManagerId" label="所属司管">
          <el-select
            v-model="searchData.driverManagerId"
            filterable
            clearable
            placeholder="请选择司管人员"
            :loading="oLoading.dmLoading"
            @change="
              (val) =>
                getSelectedLabel(val, 'driverManagerId', dmList, 'id', 'userName')
            "
          >
            <el-option
              v-for="item in dmList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="receivableStates" label="收款状态">
          <el-select
            v-model="searchData.receivableStates"
            clearable
            placeholder="请选择收款状态"
            multiple
            collapse-tags
            @change="
              (val) =>
                getSelectedLabel(val, 'receivableStates', completionStatusList)
            "
          >
            <el-option
              v-for="item in completionStatusList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="times" label="应收时间">
          <el-date-picker
            v-model="searchData.times"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="completeTime" label="完成时间">
          <el-date-picker
            v-model="searchData.completeTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="customerType" label="付款方类型">
          <el-select
            v-model="searchData.customerType"
            clearable
            placeholder="请选择"
            @change="changeCustomerType($event, 'customerType', payerList)"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in payerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerInfoType" label="客户类型">
          <el-select
            v-model="searchData.customerInfoType"
            clearable
            :disabled="searchData.customerType === 1"
            @change="
              (val) =>
                getSelectedLabel(val, 'customerInfoType', customerTypeList)
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in customerTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sourceOrderType" label="来源单类型">
          <el-select
            v-model="searchData.sourceOrderType"
            clearable
            placeholder="请选择"
            @change="
              (val) =>
                getSelectedLabel(val, 'sourceOrderType', sourceOrderTypeList)
            "
          >
            <el-option
              v-for="item in sourceOrderTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sourceOrderId" label="来源单ID">
          <el-input
            v-model="searchData.sourceOrderId"
            v-number:integer
            placeholder="请输入来源单ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item prop="content" label="收款内容">
          <el-select
            v-model="searchData.content"
            clearable
            placeholder="请选择收款内容"
            @change="
              (val) =>
                getSelectedLabel(val, 'content', freeTypeList, 'code', 'name')
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in freeTypeList"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="changeState" label="是否变更">
          <el-select
            v-model="searchData.changeState"
            clearable
            placeholder="请选择是否变更"
            @change="
              (val) => getSelectedLabel(val, 'changeState', isWhetherList)
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in isWhetherList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="relieveState" label="是否减免金额">
          <el-select
            v-model="searchData.relieveState"
            clearable
            placeholder="请选择是否减免金额"
            @change="
              (val) => getSelectedLabel(val, 'relieveState', isWhetherList)
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in isWhetherList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="id" label="应收ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect
            v-model="searchData.deptIdList"
            multiple
            :isAll="false"
            @change="
              (val, treeData) =>
                getSelectedLabel(val, 'deptIdList', treeData, 'id', 'name')
            "
          />
        </el-form-item>
        <el-form-item prop="providerId" label="车源方">
          <el-select
            v-model="searchData.providerId"
            filterable
            clearable
            placeholder="请选择车源方"
            @change="
              (val) =>
                getSelectedLabel(
                  val,
                  'providerId',
                  carProviderList,
                  'id',
                  'name'
                )
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in carProviderList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
          ></CarBrandSeriesModel>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              size="small"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="formResetFields('search')"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item>
            <PublicExport
              v-if="judgePermission('finance_receivable_excel')"
              exportTitle="应收管理导出"
              :exportTemplate="exportTemplate"
              :getSearchData="getSearchParams"
              :canExport="exportLimit"
              templateCode="receiveable-export"
              :getSearchCondition="getSearchCondition"
            ></PublicExport>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <!-- 搜索数据总览 -->
    <OperationSummary
      title="当前筛选下应收款项"
      :summary="transData"
      :loading="oLoading.summary"
    ></OperationSummary>
    <div>
      <div class="operation-box">
        <el-button
          v-if="judgePermission('finance_receivable_add')"
          size="small"
          type="primary"
          @click="addFn"
          >新增应收</el-button
        >
        <el-button
          v-if="judgePermission('changeReceivableImport')"
          size="small"
          type="primary"
          @click="gotoBatchReceivableChange"
          >批量调整应收</el-button
        >
        <el-button
          v-if="judgePermission('finance_batch_offline_collection')"
          size="small"
          type="primary"
          @click="addRecordHandle"
          >线下批量收款</el-button
        >
        <el-button
          v-if="judgePermission('batchAmountRemission')"
          size="small"
          type="primary"
          @click="gotoBatchAmountRemission"
          >批量金额减免</el-button
        >
        <el-button
          v-if="judgePermission('onlineBatchReceive')"
          size="small"
          type="default"
          @click="createMoreWithhold"
          >批量创建网约代扣</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getAllEmployeeList, getCarProvider } from '@/api/carManage'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { getCollectCustomerList } from '@/api/financeApi'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import OperationSummary from '@/components/OperationSummary'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'
import selectOption from '@/store/dict/selectOptionDict'
import moment from 'moment'
import { mapState } from 'vuex'
import { exportParams } from '../config/exportConfig'

export default {
  components: { OperationSummary, CustomerNameOptionItem },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    // 收款状态枚举
    completionStatusList() {
      return this.dictParseList(selectOption.completionStatusDict, true).filter(
        (item) => item.value !== '',
      )
    },
    // 付款方类型枚举
    payerList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },
    // 来源单类型枚举
    sourceOrderTypeList() {
      return this.dictParseList(selectOption.sourceOrderTypeDict, true)
    },
    // 是否
    isWhetherList() {
      return this.dictParseList(selectOption.isWhetherList)
    },
  },
  props: {
    currentSummary: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      exportTemplate: 'Receivable',
      searchData: {
        id: '',
        customerId: '',
        carId: '',
        sourceOrderId: '',
        sourceOrderType: '',
        receivableStates: [0, 1],
        content: '',
        customerType: 2, // 付款方类型
        times: [], // 应收时间
        completeTime: [], // 完成时间
        changeState: '', // 是否变更
        relieveState: '', // 是否减免金额
        providerId: '', // 车源方ID
        payMethod: '', // 支付方式
        customerInfoType: 1, // 客户类型
        deptIdList: [],
        driverManagerId: '', // 所属司管ID
        // 对于远程搜索的，需要把选中的label值保存，便于恢复搜索条件时可以调用远程方法
        carIdLabel: '', // 车牌号对应的label
        customerName: '', // 付款方对应的label
        customerTel: '',
      },
      brandSeriesModel: {},
      oLoading: {
        customerFuzzySearch: false,
        carFuzzySearch: false,
        search: false,
        summary: false,
        dmLoading: false,
      },
      isCustomer: false, // 付款方是否可填写
      customerList: [], // 模糊搜索付款方
      carList: [], // 模糊搜索车牌号
      carProviderList: [], // 车源方列表
      dmList: [], // 司管列表
      dmConditionList: [], // 司管列表（用于导出）
      transData: [],
      exportParams,
      customerTypeList: [
        { label: '个人', value: 1 },
        { label: '企业', value: 2 },
      ],
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    currentSummary: {
      handler(value) {
        this.handlerSummary(value)
      },
      immediate: true,
      deep: true,
    },
    brandSeriesModel: {
      handler(value) {
        const { brandId, seriesId, modelId } = value
        this.searchData.brandId = brandId
        this.searchData.seriesId = seriesId
        this.searchData.modelId = modelId
      },
      deep: true,
    },
  },
  methods: {
    triggerWindowResize() {
      // 触发 resize 事件
      const resizeEvent = new Event('resize')
      window.dispatchEvent(resizeEvent)
    },
    // 获取query上的参数
    getQueryParams() {
      const {
        sourceOrderId = '',
        receivableStates = '',
        content = '',
        sourceOrderType = '',
        times = '',
        relieveState = '',
        customerType = '',
        deptId = '',
        customerInfoType = '',
      } = this.$route.query
      if (receivableStates !== '') {
        this.searchData.receivableStates = [Number(receivableStates)]
      }
      this.searchData.sourceOrderId = sourceOrderId || ''
      if (sourceOrderType !== '') {
        this.searchData.sourceOrderType = Number(sourceOrderType)
      }
      if (content !== '') {
        this.searchData.content = Number(content)
      }
      if (relieveState !== '') {
        this.searchData.relieveState = Number(relieveState)
      }
      if (customerType !== '') {
        this.searchData.customerType = Number(customerType)
      }
      if (deptId !== '') {
        this.searchData.deptIdList = [Number(deptId)]
      }
      if (times !== '') {
        this.searchData.times = JSON.parse(times)
      }
      if (customerInfoType !== '') {
        this.searchData.customerInfoType = Number(customerInfoType)
      }
    },
    // 批量金额减免
    gotoBatchAmountRemission() {
      this.$router.push({
        path: '/finance/batchAmountRemission',
      })
    },
    addRecordHandle() {
      this.$emit('addRecordHandle', 'offline')
    },
    handlerSummary(value) {
      this.oLoading.summary = true
      if (Object.keys(value).length === 0) {
        return
      }
      const titleValueMap = {
        receivableSum: '应收金额',
        receivingSum: '收款中金额',
        commissionReceivedSum: '乾三已收款佣金',
        commissionReceivingSum: '乾三收款中佣金',
        relieveSum: '减免金额',
        receivedSum: '已收金额',
        remainSum: '剩余应收金额',
        closedSum: '已关闭应收金额',
      }
      const toolTipValueMap = {
        receivableSum: '  筛选条件下「未完成+已完成」的应收，应收金额汇总',
        receivingSum: '  筛选条件下「未完成+已完成」的应收，收款中金额汇总',
        relieveSum: '筛选条件下「未完成+已完成」的应收，减免金额汇总',
        receivedSum: '  筛选条件下「未完成+已完成」的应收，已收金额汇总',
        remainSum:
          '  筛选条件下「未完成+已完成」的应收，剩余应收金额汇总（剩余应收=应收-收款中-已收）',
        closedSum: '筛选条件下「已关闭」的应收，应收金额汇总',
      }
      const transDataObj = Object.keys(value).reduce((com, item) => {
        const subTitle = titleValueMap[item]
        const toolTip = toolTipValueMap[item]
        const obj = {
          subTitle,
          toolTip,
          numbers: value[item],
        }
        com[item] = obj
        return com
      }, {})
      // 控制顺序
      const order = [
        'receivableSum',
        'receivedSum',
        'receivingSum',
        'relieveSum',
        'remainSum',
        'closedSum',
        'commissionReceivedSum',
        'commissionReceivingSum',
      ]
      const transData = []
      order.forEach((item) => {
        if (transDataObj[item]) {
          transData.push(transDataObj[item])
        }
      })
      this.transData = transData
      this.oLoading.summary = false
    },
    gotoBatchReceivableChange() {
      this.$router.push({
        path: '/finance/collection/batchReceivableChange',
      })
    },
    // 获取车源方列表
    getCarProvider() {
      getCarProvider({
        state: 1,
        serviceType: 0,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.carProviderList = data.items
        }
      })
    },
    // 加载所有司管
    async loadAllDriverManagers() {
      this.oLoading.dmLoading = true
      try {
        const { code, data } = await getAllEmployeeList({ includeDisabled: 'YES' })
        if (code === 1) {
          this.dmList = data
          this.dmConditionList = data
        }
      } finally {
        this.oLoading.dmLoading = false
      }
    },
    // 新增
    addFn() {
      this.$emit('addFn')
    },
    createMoreWithhold() {
      this.$emit('createMoreWithhold')
    },
    // 重置
    formResetFields(form) {
      this.$refs[form].resetFields()
      this.searchData.sourceOrderId = ''
      this.searchData.deptIdList = []
      this.$refs.carBrandSeriesModelRef.reset()
      this.searchData.brandSeriesModel = {}
      this.$emit('reset')
      this.customerList = []
      this.isCustomer = this.isCustomerDisabled(this.searchData.customerType)
      this.carList = []
    },
    // 获取查询参数
    getSearchParams() {
      let startDate = ''
      let endDate = ''
      let completeStartDate = ''
      let completeEndDate = ''
      if (this.searchData.times && this.searchData.times.length) {
        startDate = this.searchData.times[0]
        endDate = this.searchData.times[1]
      }
      if (this.searchData.completeTime && this.searchData.completeTime.length) {
        completeStartDate = this.searchData.completeTime[0]
        completeEndDate = this.searchData.completeTime[1]
      }

      return {
        ...this.searchData,
        startDate,
        endDate,
        completeStartDate,
        completeEndDate,
      }
    },
    // 查询
    searchHandle() {
      this.$emit('searchHandle')
    },
    // 付款方选中类型
    changeCustomerType(val, prop, options) {
      this.searchData.customerId = ''
      this.searchData.customerInfoType = ''
      this.customerList = []
      // 类型为其他-付款方禁用，不可填写
      if (this.isCustomerDisabled(val)) {
        this.customerList = []
        this.isCustomer = true
      } else {
        this.isCustomer = false
        this.getCustomerHandle()
        this.oLoading.customerFuzzySearch = false
      }
      this.getSelectedLabel(val, prop, options)
    },
    // 模糊搜索获取车牌号
    async gerCarNoList(query) {
      // 开启远程搜索
      if (query.length >= 4) {
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          this.oLoading.fuzzySearch = false
          if (code === 1) {
            this.carList = data
          }
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      }
    },
    getCustomerHandle() {
      // 服务商
      if (this.searchData.customerType === 1) {
        this.oLoading.customerFuzzySearch = true
        getCollectCustomerList()
          .then(({ code, data }) => {
            if (code === 1) {
              this.customerList = data.items.map((item) => ({
                ...item,
                customerName: item.name,
                customerTel: item.contactTel,
              }))
            }
          })
          .finally(() => {
            this.oLoading.customerFuzzySearch = false
          })
      }
    },
    // 服务商
    // 模糊搜索获取付款方
    async getPayCustomerList(query) {
      if (query.length < 1) return
      // 开启远程搜索
      this.oLoading.customerFuzzySearch = true
      searchByCustomerNameSensitive({
        customerState: 1,
        customerName: query,
        customerType: this.searchData.customerInfoType,
        mixedType: this.searchData.customerInfoType === '' ? 'YES' : '',
      })
        .then(({ code, data = [] }) => {
          if (code === 1) {
            this.customerList = data
          }
        })
        .finally(() => {
          this.oLoading.customerFuzzySearch = false
        })
    },
    getSelectedLabel(val, prop, options, value = 'value', label = 'label') {
      const resultList = Array.isArray(val) ? val : [val]
      const config = this.exportParams.filter((item) => item.key === prop)
      if (config.length === 0) return

      const arr = resultList.map((id) => {
        const item = options.find((obj) => obj[value] === Number(id))
        return item ? item[label] : ''
      })
      config[0].matchValue = arr
    },
    exportLimit() {
      const { startDate, endDate } = this.getSearchParams()
      if (!startDate || !endDate) {
        this.$message.error('应收开始结束时间不能为空')
        return false
      }
      const start = moment(startDate, 'YYYY-MM-DD 23:59:59')
      const end = moment(endDate, 'YYYY-MM-DD 23:59:59')

      const sixMonthsBeforeEndDate = end.subtract(6, 'months')
      const isStartDateBeforeSixMonths = start.isBefore(sixMonthsBeforeEndDate)

      if (isStartDateBeforeSixMonths) {
        this.$message.error('应收开始到结束时间间隔不能大于6个月')
        return false
      }
      return true
    },
    carIdChange(val, prop, options, value, label) {
      if (!val) {
        this.carList = []
      }
      const filterItem = options.find((obj) => obj[value] === Number(val))
      this.searchData.carIdLabel = filterItem ? filterItem[label] : ''
      this.getSelectedLabel(val, prop, options, value, label)
    },
    customerIdChange(val, prop, options, value, label) {
      const filterItem = options.find((obj) => obj[value] === Number(val))
      this.searchData.customerName = filterItem ? filterItem.customerName : ''
      this.searchData.customerTel = filterItem ? filterItem.customerTel : ''
      this.getSelectedLabel(val, prop, options, value, label)
    },
    getSearchCondition() {
      const { times, completeTime } = this.searchData
      for (const key in this.searchData) {
        if (!Object.prototype.hasOwnProperty.call(this.searchData, key)) continue
        const config = this.exportParams.filter((item) => item.key === key)
        if (config.length === 0) continue
        if (key === 'times') {
          if (times && times.length && times[0] && times[1]) {
            config[0].matchValue = `${times[0]} - ${times[1]}`
            config[0].hidden = false
          } else {
            config[0].hidden = true
          }
        } else if (key === 'completeTime') {
          if (
            completeTime &&
            completeTime.length &&
            completeTime[0] &&
            completeTime[1]
          ) {
            config[0].matchValue = `${completeTime[0]} - ${completeTime[1]}`
            config[0].hidden = false
          } else {
            config[0].hidden = true
          }
        } else if (config[0].type === 'input') {
          if (this.searchData[key]) {
            config[0].matchValue = this.searchData[key]
            config[0].hidden = false
          } else {
            config[0].hidden = true
          }
        } else if (config[0].type === 'select') {
          if (this.searchData[key]) {
            if (config[0].key === 'customerId') {
              const customerItem = this.customerList.find(
                (item) => item.id === this.searchData[key],
              )
              config[0].matchValue = customerItem?.customerName || ''
            } else if (config[0].key === 'driverManagerId') {
              const selectedId = this.searchData[key]
              const list = this.dmConditionList.length > 0 ? this.dmConditionList : this.dmList
              const dmItem = list.find((item) => item.id === selectedId)
              config[0].matchValue = dmItem?.userName || ''
            } else {
              config[0].matchValue = this.searchData[key]
            }
            config[0].hidden = false
          } else if (config[0].key === 'driverManagerId') {
            config[0].matchValue = '全部'
            config[0].hidden = false
          } else {
            config[0].hidden = true
          }
        } else if (
          !this.searchData[key] ||
          (Array.isArray(this.searchData[key]) &&
            this.searchData[key].length === 0)
        ) {
          config[0].matchValue = '全部'
          if (this.searchData[key] === 0) {
            config[0].matchValue = '否'
          }
          if (this.searchData[key] === 1) {
            config[0].matchValue = '是'
          }
        }
      }
      const { brandSeries, model } = this.$refs.carBrandSeriesModelRef.getLabels()
      const result = [...this.exportParams]
      const hasBrandSeries = result.some((item) => item.label === '品牌车系')
      const hasModel = result.some((item) => item.label === '车型')
      if (!hasBrandSeries) {
        result.push(brandSeries)
      }
      if (!hasModel) {
        result.push(model)
      }
      return result
    },
    // 从sessionStorage初始化搜索条件
    initSearchData() {
      const searchData = sessionStorage.getItem('finance_collection_search_params')
      if (searchData) {
        try {
          this.searchData = JSON.parse(searchData)
          // 如果付款方类型是服务商且付款方有值
          if (this.searchData.customerType === 1 && this.searchData.customerId) {
            this.isCustomer = false
            this.getCustomerHandle()
          } else if (this.searchData.customerType === 2 && this.searchData.customerId) {
            // 如果付款方类型是客户且付款方有值
            this.isCustomer = false
            this.customerList = [{
              id: this.searchData.customerId,
              customerName: this.searchData.customerName,
              customerTel: this.searchData.customerTel,
            }]
          }
          // 对于车牌号的远程搜索
          if (this.searchData.carId) {
            this.gerCarNoList(this.searchData.carIdLabel || '')
          }
          // 对于品牌车系的处理
          if (this.searchData.brandId) {
            this.brandSeriesModel = {
              brandId: this.searchData.brandId,
              seriesId: this.searchData.seriesId,
              modelId: this.searchData.modelId,
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    isCustomerDisabled(type) {
      return type === 3 || !type
    },
  },
  mounted() {
    this.getQueryParams()
    this.initSearchData()
    // 搜索条件展开
    this.$refs.qsSearchRef?.searchMoreClick()
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.getCarProvider()
    this.loadAllDriverManagers()
  },
  activated() {
    this.triggerWindowResize()
  },
}
</script>
<style lang="scss" scoped>
.operation-box {
  align-content: center;
  padding-top: 16px;
}
</style>
